module.exports = __webpack_public_path__ + "assets/36c5ea6dd1f0301b2353cf8431da7397.json";